import { CommonModule, Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { finalize, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';
import { EEntite } from 'src/enum/eEntite';
import { ContenuSessionModel as ContenuSessionModel } from '../../../../models/contenuSessionModel';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ContenuSessionService } from 'src/services/contenu.session.service';
import moment from'moment-timezone';
import { EtiquetteSessionModel } from 'src/models/etiquetteSessionModel';
import { MatDialog } from '@angular/material/dialog';
import { ChoixLangueCertificatDialogComponent } from './choix-langue-certificat-dialog/choix-langue-certificat-dialog.component';
import { ConfirmationExportDialogComponent } from '../../../../commun/dialog/confirmation-export-dialog/confirmation-export-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EtiquetteService } from 'src/services/etiquette.service';
import { MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { StatePersistenceService } from 'src/services/state-persistence.service';
import { ContenusCompleteState, validateContenusCompleteState } from 'src/models/contenus-complete-state.model';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { StringHelpers } from 'src/models/helpers/string-helpers';
registerLocaleData(localeFr);

@Component({
    selector: 'app-contenus-complete',
    templateUrl: './contenus-complete.component.html',
    styleUrls: ['./contenus-complete.component.scss'],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntlService }],
    imports: [
        CommonModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatCheckboxModule,
        TranslateModule,
        MatFormFieldModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatTableModule,
        MatPaginator,
        MatSortModule,
        MatButtonModule,
        TiretPipe,
        MatDatepickerModule,
        MatNativeDateModule
    ]
})
export class ContenusCompleteComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;
  momentDate = moment;
  contenus: ContenuSessionModel[] = [];
  isLoading: boolean = false;
  contenusAffiches: ContenuSessionModel[] = [];
  contenusFiltreEnCours: ContenuSessionModel[] = [];
  sessionModelCertificat: ContenuSessionModel[] = [];
  selectionGroupe: number[] = [];
  selectionOrganisation: number[] = [];
  selectionTitreContenu: string[] = [];
  selectionEtiquette: number[] = [];
  selectionDateAcces: string = "last30days";
  selectionFormationGroupe: string = '';
  textRechercher: string = "";
  dateDebut!: Date | undefined;
  dateFin!: Date | undefined;
  utilisateurId: number = 0;
  groupeIdsSelection: string[] = [];
  organisationIdsSelection: string[] = [];
  etiquetteIdsSelection: string[] = [];
  contenusSelection: string[] = [];
  groupes: OrganisationModel[] = [];
  organisations: OrganisationModel[] = [];
  titres: string[] = [];
  etiquettes: EtiquetteSessionModel[] = [];

  groupFilterCtrl: FormControl = new FormControl();
  orgFilterCtrl: FormControl = new FormControl();
  titreFilterCtrl: FormControl = new FormControl();
  etiquetteFilterCtrl: FormControl = new FormControl();

  filteredOrganisations: ReplaySubject<OrganisationModel[]> = new ReplaySubject<OrganisationModel[]>(1);
  filteredGroupes: ReplaySubject<OrganisationModel[]> = new ReplaySubject<OrganisationModel[]>(1);
  filteredTitres: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  filteredEtiquettes: ReplaySubject<EtiquetteSessionModel[]> = new ReplaySubject<EtiquetteSessionModel[]>(1);

  _onDestroy = new Subject<void>();

  displayedColumns: string[] = [
    'dateDernierModification',
    'dateDemarrage',
    'organisation',
    'etiquettes',
    'prenomNom',
    'titre',
    'duree',
    'actions'
  ];

  provenance: string = "";
  entiteId!: number;
  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  textFilter: string = '';
  afficherSpinner: boolean = true;
  isFiltering: boolean = false;

  dataSource!: MatTableDataSource<ContenuSessionModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private readonly COMPONENT_KEY = 'contenus-complete';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | '' = '';

  constructor(private utilisateurServicePilotage: UtilisateurService,
    public etiquetteService: EtiquetteService,
    private router: Router,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private contenuSessionService: ContenuSessionService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private location: Location,
    private statePersistenceService: StatePersistenceService) {
    this.dataSource = new MatTableDataSource<ContenuSessionModel>([]);
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      if (!isNaN(Number.parseInt(params['id']))) {
        this.utilisateurId = Number.parseInt(params['id']);
      }
    });

    this.loadState();

    if (window.location.pathname.includes('pilotage') || window.location.pathname.includes('rapports')) {
      this.provenance = 'pilotage';
      this.obtenirContenusSessionsRole();
    } else if (window.location.pathname.includes('profil-utilisateur')) {
      this.provenance = 'profil-utilisateur';
      this.obtenirContenusSessionsUtilisateur()
    }

    if (this.estShowGroupeColumn) {
      this.displayedColumns.splice(2, 0, 'groupe');
    }

    this.ajusterColonnesTableSelonPage();

    this.bindFiltredCtl();

    window.addEventListener('export-excel', (event: any) => {
      if (event.detail &&
        ((event.detail.filter === 'complete' && this.estPageContenuComplete) ||
          (event.detail.filter === 'encours' && !this.estPageContenuComplete))) {
        this.exporterVersExcel();
      }
    });

    window.addEventListener('export-pdf', (event: any) => {
      if (event.detail &&
        ((event.detail.filter === 'complete' && this.estPageContenuComplete) ||
          (event.detail.filter === 'encours' && !this.estPageContenuComplete))) {
        this.exporterVersPdf();
      }
    });
  }

  get estPageContenuComplete(): boolean {
    return window.location.pathname.includes('complete');
  }

  ngOnDestroy() {
    this.saveState();
    this._onDestroy.next();
    this._onDestroy.complete();

    window.removeEventListener('export-excel', (event: any) => {
      if (event.detail &&
        ((event.detail.filter === 'complete' && this.estPageContenuComplete) ||
          (event.detail.filter === 'encours' && !this.estPageContenuComplete))) {
        this.exporterVersExcel();
      }
    });

    window.removeEventListener('export-pdf', (event: any) => {
      if (event.detail &&
        ((event.detail.filter === 'complete' && this.estPageContenuComplete) ||
          (event.detail.filter === 'encours' && !this.estPageContenuComplete))) {
        this.exporterVersPdf();
      }
    });
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.contenus.length;
      this.refreshDataSource();
    }
  }

  onDateChange() {
    if (this.dateDebut && this.dateFin) {
      this.picker.close();
      this.filtreDateAcces();
    }
  }

  onModeCustomDate() {
    setTimeout(() => this.picker.open(), 500);
  }

  resetSelectCustumDate() {
    this.dateDebut = undefined;
    this.dateFin = undefined;
  }

  sortDataChange(sortState: Sort) {
    this.sortColumn = sortState.active;
    this.sortDirection = sortState.direction as 'asc' | 'desc' | '';

    if (sortState.direction) {
      this.dataSource.sortingDataAccessor = (item: any, property: string) => {
        const value = item[property];
        if ((property === 'organisation' || property === 'groupe') && typeof value === 'object' && value !== null) {
          return StringHelpers.removeDiacritics(value.nom);
        }
        return typeof value === 'string' ? StringHelpers.removeDiacritics(value) : value;
      };
      this.dataSource.sort = this.sort;
    }
  }

  ajusterColonnesTableSelonPage() {
    if (this.estPageContenuComplete) {
      var indexDateDernierModification = this.displayedColumns.indexOf('dateDernierModification');
      var indexAction = this.displayedColumns.indexOf('action');
      this.displayedColumns.splice(indexDateDernierModification, 1, 'dateComplete');
      var indexDateDemarrage = this.displayedColumns.indexOf('dateDemarrage');
      this.displayedColumns.splice(indexDateDemarrage, 1);
      this.displayedColumns.splice(6, 0, 'note');
      this.displayedColumns.splice(indexAction, 0, 'estDonneCertificat');
      this.displayedColumns.splice(indexAction, 0, 'estCompleteEnGroupe');
    }
  }


  openChoixLangueDialog(): void {
    const dialogRef = this.dialog.open(ChoixLangueCertificatDialogComponent, {
      width: '500px',
      disableClose: true,
      data: this.sessionModelCertificat as ContenuSessionModel[],
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  get estShowGroupeColumn(): boolean {
    return this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRoot || this.utilisateurServicePilotage.estRolePiloteOuAdmin();
  }

  get estModeDemo(): boolean {
    return this.utilisateurServicePilotage.entiteUtilisateurSelectionnee?.estDemo || false;
  }

  private bindFiltredCtl() {
    this.groupFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtreGr();
      });

    this.orgFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtreOrg();
      });

    this.etiquetteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredEtq();
      });

    this.titreFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredTitre();
      });
  }

  private filtreGr() {
    if (!this.groupes) {
      return;
    }
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredGroupes.next(this.groupes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGroupes.next(
      this.groupes.filter(entite => entite.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  private filtreOrg() {
    if (!this.organisations) {
      return;
    }
    let search = this.orgFilterCtrl.value;
    if (!search) {
      this.filteredOrganisations.next(this.organisations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOrganisations.next(
      this.organisations.filter(entite => entite.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  private filtredEtq() {
    if (!this.etiquettes) {
      return;
    }
    let search = this.etiquetteFilterCtrl.value;
    if (!search) {
      this.filteredEtiquettes.next(this.etiquettes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEtiquettes.next(
      this.etiquettes.filter(etq => this.etiquetteService.getNomLocalise(etq.locales).toLowerCase().indexOf(search) > -1)
    );
  }

  private filtredTitre() {
    if (!this.titres) {
      return;
    }
    let search = this.titreFilterCtrl.value;
    if (!search) {
      this.filteredTitres.next(this.titres.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTitres.next(
      this.titres.filter(titre => titre.toLowerCase().indexOf(search) > -1)
    );
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.contenusAffiches = this.contenusFiltreEnCours.slice(startIndex, endIndex);
    this.dataSource.data = this.contenusAffiches;
    this.changeDetectorRef.detectChanges();
    this.saveState();
  }

  filtreGroupe(): void {
    let filtered = [...this.groupes];
    if (this.selectionGroupe.length > 0) {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter((contenus) => {
        if (contenus.groupe !== undefined && contenus.groupe !== null) {
          return this.selectionGroupe.includes(contenus.groupe.entiteId)
        }
        return false;
      });
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    }
    this.filteredGroupes.next(filtered);
  }

  filtreOrganisation(): void {
    let filtered = [...this.organisations];
    if (this.selectionOrganisation.length > 0) {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenus => {
        if (contenus.organisation !== undefined && contenus.organisation !== null) {
          return this.selectionOrganisation.includes(contenus.organisation.entiteId);
        }
        return false;
      });
    } else {
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    }
    this.filteredOrganisations.next(filtered);
  }

  filtreEtiquettes(): void {
    let filtered = [...this.etiquettes];
    if (this.selectionEtiquette.length > 0) {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenus => {
        if (contenus.etiquettes !== undefined && contenus.etiquettes !== null && contenus.etiquettes.length > 0) {
          return this.selectionEtiquette.every(id => contenus.etiquettes.some(et => et.etiquetteId === id))
        }
        return false;
      });
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    }
    this.filteredEtiquettes.next(filtered);
  }

  filtreTitreContenus(): void {
    if (this.selectionTitreContenu.length > 0) {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenus => this.selectionTitreContenu.includes(contenus.titre));
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else {
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    }
  }
  filtreDateAcces(): void {
    if (this.selectionDateAcces == 'alldate') {
      this.dateDebut = this.momentDate(this.momentDate().subtract(50, 'years')).startOf('years').toDate();
      this.dateFin = this.momentDate().endOf('month').toDate();;
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'today') {
      this.dateDebut = this.momentDate().startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isSame(this.momentDate(), 'day'));
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'yesterday') {
      this.dateDebut = this.momentDate().subtract(1, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().subtract(1, 'days').endOf('day').toDate();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isSame(this.momentDate().subtract(1, 'days'), 'day'));
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'week') {
      this.dateDebut = this.momentDate().subtract(6, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate().subtract(6, 'days').startOf('day'), this.momentDate().endOf('day'), undefined, '[]'));
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'last30days') {
      this.dateDebut = this.momentDate().subtract(29, 'days').startOf('day').toDate();
      this.dateFin = this.momentDate().endOf('day').toDate();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate().subtract(29, 'days').startOf('day'), this.momentDate().endOf('day'), undefined, '[]'));
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'year') {
      this.dateDebut = this.momentDate().startOf('years').toDate();
      this.dateFin = this.momentDate().endOf('years').toDate();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().year() === this.momentDate().year());
      this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
    } else if (this.selectionDateAcces == 'custom') {
      if (this.dateDebut && this.dateFin) {
        this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => this.momentDate(contenu.dateComplete).local().isBetween(this.momentDate(this.dateDebut).local().toDate(), this.momentDate(this.dateFin).local().toDate()));
        this.dataSource = new MatTableDataSource(this.contenusFiltreEnCours);
      }
    }
    if (this.provenance === 'pilotage' && this.selectionDateAcces != '') {
      this.obtenirContenusSessionsRole();
    } else if (this.provenance === 'profil-utilisateur' && this.selectionDateAcces != '') {
      this.obtenirContenusSessionsUtilisateur();
    }
    this.saveState();
  }

  filtre(): void {
    if (this.isFiltering) return;
    this.isFiltering = true;

    try {
      this.applyFilters();

    } finally {
      this.isFiltering = false;
    }
  }

  private applyFilters(): void {
    this.pageIndex = 0;
    this.contenusFiltreEnCours = this.contenus;
    this.filtreGroupe();
    this.filtreOrganisation();
    this.filtreTitreContenus();
    this.filtreEtiquettes();
    this.filtreFormationGroupe();
    this.filtreRecherche();
    this.totalItems = this.contenusFiltreEnCours.length;
    this.paginer();
    this.saveState();
  }

  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.contenusFiltreEnCours.length;
      this.totalItems = this.contenusFiltreEnCours.length;
      this.paginator.page.emit();
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.contenusFiltreEnCours = this.contenus;
    this.dataSource.data = this.contenusFiltreEnCours;
    this.updatePaginatorLength();
  }

  reinitialiserFiltre(): void {
    this.selectionGroupe = [];
    this.selectionOrganisation = [];
    this.selectionTitreContenu = [];
    this.selectionEtiquette = [];
    this.selectionDateAcces = "last30days";
    this.selectionFormationGroupe = '';
    this.textRechercher = "";
    this.pageIndex = 0;
    this.sortColumn = '';
    this.sortDirection = '';
    this.applyFilters();
    if (this.sort) {
      this.sort.active = '';
      this.sort.direction = '';
      this.sort._stateChanges.next();
    }
  }

  filtreFormationGroupe(): void {
    if (this.selectionFormationGroupe === 'groupe') {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => contenu.estCompleteEnGroupe === true);
    } else if (this.selectionFormationGroupe === 'individuel') {
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => !contenu.estCompleteEnGroupe);
    }
  }

  filtreRecherche(): void {
    if (this.textRechercher && this.textRechercher.length > 2) {
      const textRechercher = this.textRechercher.trim().toLowerCase();
      this.contenusFiltreEnCours = this.contenusFiltreEnCours.filter(contenu => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };

        return Object.values(contenu).some(value => checkValue(value));
      });
    }
  }

  private setDefaultFilters(): void {
    this.selectionDateAcces = "last30days";
  }

  private obtenirContenusSessionsRole() {
    this.isLoading = true;
    var entiteId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee.entiteId;
    var utilisateurId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee.utilisateurId;
    var estRoot = this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRoot || this.utilisateurServicePilotage.selectionEntiteUtilisateur.estRootLectureSeule;
    this.contenuSessionService.obtenirContenuSessionsSelonRole(entiteId, utilisateurId, estRoot, this.dateDebut!, this.dateFin!).subscribe((reponse) => {
      if (this.estPageContenuComplete) {
        this.contenus = reponse.filter(contenu => contenu.dateComplete !== null);
      } else {
        this.contenus = reponse.filter(contenu => contenu.dateComplete === null);
      }
      this.mapperFiltres(this.contenus);
      this.loadState();
      this.applyFilters();
      this.isLoading = false;

      window.dispatchEvent(new CustomEvent('data-loaded', {
        detail: { hasData: this.contenus.length > 0 }
      }));
    });
  }

  private obtenirContenusSessionsUtilisateur() {
    this.isLoading = true;
    var utilisateurId: number = 0;
    if (this.utilisateurId != null && this.utilisateurId != undefined && this.utilisateurId > 0) {
      utilisateurId = this.utilisateurId;
    } else {
      utilisateurId = this.utilisateurServicePilotage.selectionEntiteUtilisateur.entiteUtilisateurs[0].utilisateurId;
    }
    this.contenuSessionService.obtenirContenuSessionSelonUtilisateur(utilisateurId, this.dateDebut, this.dateFin).subscribe((reponse) => {
      if (this.estPageContenuComplete) {
        this.contenus = reponse.filter(contenu => contenu.dateComplete !== null);
      } else {
        this.contenus = reponse.filter(contenu => contenu.dateComplete === null);
      }
      this.mapperFiltres(this.contenus);
      this.loadState();
      this.applyFilters();
      this.isLoading = false;

      window.dispatchEvent(new CustomEvent('data-loaded', {
        detail: { hasData: this.contenus.length > 0 }
      }));
    });
  }

  private mapperFiltres(contenusession: ContenuSessionModel[]) {
    this.groupes = Array.from(
      new Map(contenusession.map(contenu => [contenu.groupe.entiteId, contenu.groupe])).values()
    ).sort((a, b) => (a.nom ?? '').localeCompare(b.nom ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredGroupes.next(this.groupes);

    const etiquettes = contenusession.map(contenu => contenu.etiquettes).flat();
    this.etiquettes = Array.from(
      new Map(etiquettes.map(etq => [this.etiquetteService.getNomLocalise(etq.locales), etq])).values()
    ).sort((a, b) =>
      this.etiquetteService.getNomLocalise(a.locales).localeCompare(
        this.etiquetteService.getNomLocalise(b.locales), 'fr', { sensitivity: 'base' }
      )
    );
    this.filteredEtiquettes.next(this.etiquettes);

    this.organisations = Array.from(
      new Map(contenusession.map(contenu => [contenu.organisation.entiteId, contenu.organisation])).values()
    ).sort((a, b) => (a.nom ?? '').localeCompare(b.nom ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredOrganisations.next(this.organisations);

    this.titres = [...new Set(contenusession.map(contenu => contenu.titre))]
      .sort((a, b) => (a ?? '').localeCompare(b ?? '', 'fr', { sensitivity: 'base' }));
    this.filteredTitres.next(this.titres);
  }

  obtenirRapportInteraction(sessionId: number): void {
    this.router.navigate(['contenus-managment', 'session-evenement', sessionId]);
  }

  telechargerCertificat(contenuSession: ContenuSessionModel) {
    this.sessionModelCertificat = [];
    this.sessionModelCertificat.push(contenuSession);
    this.openChoixLangueDialog();
  }

  exporterVersExcel(): void {
    const ids = this.contenusFiltreEnCours.map(c => c.id);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'CONTENUS_MANAGEMENT.EXPORT_EXCEL' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translateService.currentLang || 'fr';
        this.contenuSessionService.exporterContenus(ids, codeLangue).pipe(
          finalize(() => this.isLoading = false)
        ).subscribe(({ blob, contentType }) => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `contenus_${datetime}.xlsx`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        });
      }
    });
  }

  exporterVersPdf(): void {
    const ids = this.contenusFiltreEnCours.map(c => c.id);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'CONTENUS_MANAGEMENT.EXPORT_PDF' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translateService.currentLang || 'fr';
        this.contenuSessionService.exporterContenusPdf(ids, codeLangue).pipe(
          finalize(() => this.isLoading = false)
        ).subscribe(blob => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `contenus_${datetime}.pdf`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        });
      }
    });
  }

  telechargerDocument(blob: Blob, extension: string, nom: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nom}${extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  Retour(): void {
    this.location.back();
  }

  private saveState(): void {
    const state: ContenusCompleteState = {
      selectionGroupe: this.selectionGroupe,
      selectionOrganisation: this.selectionOrganisation,
      selectionTitreContenu: this.selectionTitreContenu,
      selectionEtiquette: this.selectionEtiquette,
      selectionDateAcces: this.selectionDateAcces,
      selectionFormationGroupe: this.selectionFormationGroupe,
      textRechercher: this.textRechercher,
      dateDebut: this.dateDebut!,
      dateFin: this.dateFin!,
      groupeIdsSelection: this.groupeIdsSelection,
      organisationIdsSelection: this.organisationIdsSelection,
      etiquetteIdsSelection: this.etiquetteIdsSelection,
      contenusSelection: this.contenusSelection,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };

    const contextId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee?.entiteId;
    this.statePersistenceService.saveState(this.COMPONENT_KEY, state, contextId);
  }

  private loadState(): void {
    const contextId = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee?.entiteId;

    if (!contextId || contextId === EEntite.ROOT_ENTITE_ID) {
      this.initializeDefaultDates();
      return;
    }

    const savedState = this.statePersistenceService.loadState(this.COMPONENT_KEY, contextId);

    if (savedState) {
      const validatedState = validateContenusCompleteState(savedState);

      this.selectionGroupe = validatedState.selectionGroupe;
      this.selectionOrganisation = validatedState.selectionOrganisation;
      this.selectionTitreContenu = validatedState.selectionTitreContenu;
      this.selectionEtiquette = validatedState.selectionEtiquette;
      this.selectionDateAcces = validatedState.selectionDateAcces;
      this.selectionFormationGroupe = validatedState.selectionFormationGroupe;
      this.textRechercher = validatedState.textRechercher;
      this.dateDebut = validatedState.dateDebut;
      this.dateFin = validatedState.dateFin;
      this.groupeIdsSelection = validatedState.groupeIdsSelection;
      this.organisationIdsSelection = validatedState.organisationIdsSelection;
      this.etiquetteIdsSelection = validatedState.etiquetteIdsSelection;
      this.contenusSelection = validatedState.contenusSelection;
      this.pageIndex = validatedState.pageIndex;
      this.pageSize = validatedState.pageSize;
    } else {
      this.initializeDefaultDates();
    }
  }

  private initializeDefaultDates(): void {
    if (this.selectionDateAcces === 'last30days') {
      this.dateDebut = moment().subtract(30, 'days').toDate();
      this.dateFin = moment().toDate();
    }
  }

}
